import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ios-arrow-forward",
  "use": "ios-arrow-forward-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"ios-arrow-forward\"><path d=\"M287.3 256L160 383.6l32.3 32.4L352 256 192.3 96 160 128.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol